import { ServiceAdminApi } from './api'

export default class ServiceAdminService {
    
  constructor() {
    this.serviceAdminApi = new ServiceAdminApi()
  }

  getGuage() {
    return this.serviceAdminApi.getGuage()
  }

  updGuage(params) {
    return this.serviceAdminApi.updGuage(params)
  }

  getBody() {
    return this.serviceAdminApi.getBody()
  }

  updBody(params) {
    return this.serviceAdminApi.updBody(params)
  }

  getTriangle() {
    return this.serviceAdminApi.getTriangle()
  }

  updTriangle(params) {
    return this.serviceAdminApi.updTriangle(params)
  }

  getInjury() {
    return this.serviceAdminApi.getInjury()
  }

  updInjury(params) {
    return this.serviceAdminApi.updInjury(params)
  }
}
